import { defineMessages } from 'react-intl';

const messages = defineMessages({
  emptyTagList: {
    defaultMessage: 'No Tags Added',
    id: 'WxR8Bb',
    description: "message to display when the seller doesn't have any tags created",
  },
  clearTags: {
    defaultMessage: 'Clear Tags',
    id: 'IUeOT+',
    description: 'button to allow users to remove all tags assiciated with fulfillment plan',
  },
  saveTags: {
    defaultMessage: 'Apply',
    id: 'yNjzOL',
    description: 'button to allow users to save changes made to tags assiciated with fulfillment plan',
  },
  addTags: {
    defaultMessage: 'Add Tags',
    id: 'mAan+F',
    description: 'button to allow users to save changes made to tags assiciated with fulfillment plan',
  },
  bulkUpdateTagsSuccessTitle: {
    defaultMessage: 'Tags Successfully Updated',
    id: 'GX7/If',
    description: 'title to display when tags are successfully updated',
  },
  bulkUpdateTagsErrorTitle: {
    defaultMessage: 'Error Updating Tags',
    id: 'KfJK4f',
    description: 'title to display when tags are not successfully updated',
  },
  bulkUpdateTagsErrorMessage: {
    defaultMessage: 'There was an error updating the tags. Please try again.',
    id: 'YBdAg0',
    description: 'message to display when tags are not successfully updated',
  },
  bulkUpdateCheckBoxMessage: {
    defaultMessage: 'All open shipments',
    description: 'label for a checkbox that when clicked will "bulk update" all orders with the current address',
    id: 'teHhPc',
  },
});
export default messages;
